import { IAuthorWithContribution } from '@publishing-engine/domain/models';
import _ from 'lodash';

export type IAuthorRolesMap = {
  Submitting: string;
  Contact?: string;
  Corresponding?: string;
};

export const groupAuthorsByRoles = (
  roles: IAuthorRolesMap,
  authorList: IAuthorWithContribution[] = []
) =>
  _(roles)
    .map((email, role) => ({ email, role }))
    .groupBy('email')
    .map((items, email) => {
      const user = _.find(authorList, { email })!;

      return {
        ...user,
        roles: _.map(items, 'role')
      };
    })
    .value();
